import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Slice } from '../../types';
import { OrderStatus, PaymentResult, PaymentStateModel } from './models';
import { confirmPayment, createOrder, getOrder } from './operations';

const initialState = {
  orderStatus: null,
  receiptUrl: null,
} as PaymentStateModel;

const paymentSlice = createSlice({
  name: Slice.Payment,
  initialState: initialState,
  reducers: {
    clearOrderStatus: (state) => {
      state.orderStatus = null;
      state.receiptUrl = null;
    },
  },
  extraReducers(builder) {
    builder.addCase(createOrder.fulfilled, (state, action: PayloadAction<OrderStatus | null>) => {
      console.log('[Payment slice] Setting orderStatus ' + action.payload?.orderId);
      state.orderStatus = action.payload;
    });
    builder.addCase(getOrder.fulfilled, (state, action: PayloadAction<OrderStatus | null>) => {
      console.log('[Payment slice] Setting orderStatus ' + action.payload?.orderId);
      state.orderStatus = action.payload;
    });
    builder.addCase(confirmPayment.fulfilled, (state, action: PayloadAction<PaymentResult | null>) => {
      console.log('[Payment slice] Setting receiptUrl ' + action.payload?.receiptUrl);
      state.receiptUrl = action.payload?.receiptUrl ?? null;
    });
  },
});

export const { clearOrderStatus } = paymentSlice.actions;
export default paymentSlice.reducer;
